module.exports = __webpack_public_path__ + "img/tab4.1ff23942.png";